import React from 'react'
import { createContainer } from '@dbk-legacy/muster/react'
import Spinner from '@dbk/ui-spinner';
import Text, { Small, Large, H1, H3 } from '@dbk/ui-text';
import Button from '@dbk/ui-buttons';
import Modal from '@dbk/ui-modal';
import {Checkbox} from '@dbk/ui-forms';
import {Currency} from '../../components/common/number';
import format from 'date-fns/format';
import PaymentError from './payment-error'
import ConfirmationModal from './payment-confirmation-modal'
import CancelModal from './payment-cancel-modal'
import StatusModal from './payment-status-modal'
import { ErrorIcon } from '../../components/common/icons';
import { ROUTES, EBANKINGWEBUK, EBANKINGWEBLUX, RM_REGION_UK, ALL_CHARGES_EN, ALL_CHARGES_DE,  RM_REGION_CH, EBANKINGWEB, RM_REGION } from '../../constants';
import TransactionSecurityAdvice from '../../../@extension/CH/src/scenes/portfolio/transactions-global/transaction-security-advice/transaction-security-advice';
import styles from './payment-summary.styles';
import { PAYMENT_TYPE} from './constant';
import envConfig from '../../../db-env-build';

const { PAYMENT } = ROUTES;

class PaymentSummary extends React.PureComponent {
  state = {
    showConfirmationModal: false,
    showCancelModal: false,
    showStatusModal: false,
    showExpireModal: false,
    status: 'success',
    validRequest:true
  }

  onDone = () => {
    const {payments: {isCashFlow,isCashPaymentFlow} } = this.props;
    this.props.payments.resetForm();
    this.props.payments.setPosid('');
    if(isCashFlow) {
      if(isCashPaymentFlow){
      this.props.payments.setCreateNewModal(false)   //WMCE-41878- For disabling new create modal 
      this.props.payments.setFlowFalse(false);
      this.props.payments.setIsCashPaymentFlow(false);  //WMCE-49821- To enable arrow due to asyncronous behaviour
      this.props.payments.setDisableTabs(false);     //WMCE-41840- For enabling Menu bar
      this.props.changePage(ROUTES.CASH_ACCOUNTS.SUMMARY_CASH_ACCOUNTS_ROUTE);
      }
      else{
      this.props.payments.setCreateNewModal(false)   //WMCE-41878- For disabling new create modal 
      this.props.payments.setFlowFalse(false);
      this.props.portfolio.setAssetClassName('liquidity');
      this.props.changePage('/portfolios', true);
      this.props.payments.setDisableTabs(false);     //WMCE-41840- For enabling Menu bar
      this.props.changePage('/portfolios/genericAssets');
      }
    } else {
      this.props.payments.setFlowFalse(false);
      localStorage.setItem('newPaymentComplete',true);
      this.props.changePage(PAYMENT.DASHBOARD);
    }
  }
  onModify = () => this.props.changePage(PAYMENT.NEW_DOMESTIC)
  onRefresh = () => this.props.payments.getRefreshStatus()

  onConfirm = async () => {
    if(this.props.payments.isSaveEnabled)
      await this.props.payments.saveTemplate();
      await this.props.verifyChallengeResponse();
      this.toggleModal('showConfirmationModal',this.state.validRequest) ; 
  }

  onTimeout = () => this.cancelPayment(true, true)
  // * isNewPayment=true means a new created and valid payment from web,
  // * if false, meaning it is an existing payment from dashboard,
  cancelPayment = async (isNewPayment=false, timeout=false, cancelFromWeb=false, e) => {
    const {
      cancelTx,
      resetForm,
    } = this.props.payments
    resetForm();
    if (isNewPayment) {
      if (timeout) {
        await cancelTx()
        this.setState({ showExpireModal: true })
      } else if (cancelFromWeb) {
        await cancelTx()
        this.setState({
          showStatusModal: false,
          status: 'reject'
        })
      } else {
        this.setState({
          showStatusModal: true,
          status: 'reject'
        })
      }
    } else {
      cancelTx()
      this.setState({
        showCancelModal: false,
        showStatusModal: false,
        status: 'reject'
      })
    }
  }
  donePayment = () => {
    this.setState({
      showStatusModal: true,
      status: 'success'
    })
  }
  goNewPayment = () => {
    this.props.payments.setCreateNewModal(true)
    this.onDone()
  }
  toggleModal = (modalName, status=true) => {
    this.setState({ [`${modalName}`]: status })
  }

  componentDidUpdate(){
    if(document.querySelector('div.proceed')){
      document.querySelector('div.proceed').focus();
    }
    if(document.querySelector('button.btnPaymentDone')){
      document.querySelector('button.btnPaymentDone').focus();
    }
    if(document.querySelector('button.btnProceed')){
      document.querySelector('button.btnProceed').focus();
    }
  }

  async componentWillReceiveProps(nextProps) {
    if (nextProps.payments.isRequestInvalid === true ) {
      this.setState({
        validRequest: false,
        showStatusModal: true,
        status: 'terminate'
      })
      this.setState({ showConfirmationModal: false})
    }
  }
  componentWillUnmount() {
    this.props.payments.setErrorMsg(null);     //WMCE-12018- To remove error message when go back to payment form from payment summary
  }
  async componentWillReceiveProps(nextProps) {
    if (nextProps.payments.isRequestInvalid === true ) {
      this.setState({
        validRequest: false,
        showStatusModal: true,
        status: 'terminate'
      })
      this.setState({ showConfirmationModal: false})
    }
  }

  render () {
    const {
      i18n: { messages },
      payments: {
        initializeTxFails,
        isValidatingPayment,
        isFetchingTx,
        transactionId,
        tppName,
        isModifyFlow,
        remarks,
        currentTx: {
          orderId,
          accName,
          accNo,
          pfId,
          accBal,
          accBalCode,
          asOfDate='',
          beneficiaryName,
          address1,
          address2,
          address3,
          ibanNo,
          bankName,
          swiftCode,
          currencyAmount,
          currencyAmountCode,
          executionDate='',
          valueDate,
          costs,
          status,
          editable,
          cancelable,
          confirmable,
          externalOrderId,
          ntnlId,
          sortCode,
          transactionFee,
          forexText
        },
        paymentType,
        refreshStatus,
        errorMsgs,
        selectedDebitAcnt,
      },
      auth: { paymentSubmitDisabled }
    } = this.props

    if (isValidatingPayment || isFetchingTx)
      return <div className="spinnerPosition"><Spinner size="large"/></div>
    if (initializeTxFails) {
      let msg = (errorMsgs && errorMsgs[0].errorDesc) ? errorMsgs[0].errorDesc : messages['app.payments.failToConnect']
      if (initializeTxFails==='acp.down') {
        msg = messages['app.payment.error.acp.down']
      }
      return (
        <Modal
          isActive
          onClose={() => this.props.changePage(PAYMENT.DASHBOARD)}
          content={
            <div className="small-12 row" style={{paddingBottom: '20px', paddingTop: '10px'}}>
              <div className="column small-2">
                <ErrorIcon width={30} height={30} />
              </div>
              <div className="column small-10" role="alert" tabIndex={0}>
                <Text secondary>{msg}</Text>
              </div>
            </div>
          }
        />
      )
    }
    let transactionDtsForAdvice;
    if(this.props.payments.currentTx && this.props.payments.selectedDebitAcnt){
      transactionDtsForAdvice = {
        posId: selectedDebitAcnt.psPosId,
        transactionDate:this.props.payments.currentTx.executionDate,
        transactionNo: this.props.payments.currentTx.externalOrderId,
      }
    }
    const {
      showConfirmationModal,
      showCancelModal,
      showStatusModal,
      showExpireModal,
    } = this.state
    // todo: for internal transfer
    const isInternal = paymentType.includes('internal')
    const isDomestic = paymentType.includes('domestic')
    const isUKRegion = (envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK);
    const showCosts = !(paymentType.includes('internal') || paymentType.includes('sepa') || isUKRegion)
    const isInternational = paymentType.includes(PAYMENT_TYPE.international);
    let pageTitle = messages['app.payment.pageTitle.summaryDomestic']
    let swiftOrNtnlId = ntnlId?(' ('+ntnlId+')') : ''
    if (paymentType === "international-payments") {
      pageTitle = messages['app.payment.pageTitle.summaryInternational']
      swiftOrNtnlId = swiftCode?(' ('+swiftCode+')') : ''
    } else if(paymentType === "sepa-payments") {
      pageTitle = messages['app.payment.pageTitle.summarySepa']
      swiftOrNtnlId = swiftCode?(' ('+swiftCode+')') : ''
    } else if(paymentType === "internal-payments") {
      pageTitle = messages['app.payment.pageTitle.summaryInternal']
      swiftOrNtnlId = ' ' + swiftCode
    }else if(paymentType === "swissqrbill-payments") {
      pageTitle = messages['app.payment.pageTitle.summaryQRBillPayment']
      swiftOrNtnlId = ' ' + swiftCode
    }
    const bankSwift = swiftOrNtnlId
    const fmtAsOfDate = asOfDate && asOfDate.length===10? format(asOfDate, 'DD MMM YYYY') : asOfDate
    let fmtValueDate = '' // if valueDate null
    if (valueDate) {
      fmtValueDate = valueDate.length===10?format(valueDate, 'DD MMM YYYY'):valueDate
    }
    let fmtExecutionDate = ''
    if (executionDate) {
      fmtExecutionDate = executionDate.length===10?format(executionDate, 'DD MMM YYYY'): executionDate
    }

    let checkSortCode = sortCode ? sortCode : ntnlId;

    let sortCodeFormat= (checkSortCode && typeof(checkSortCode) === 'string') ? checkSortCode : (checkSortCode && typeof(checkSortCode) === 'number') ? checkSortCode.toString() : '';
    if(checkSortCode && sortCodeFormat.length === 6){
      sortCodeFormat = `${sortCodeFormat.slice(0,2)}-${sortCodeFormat.slice(2,4)}-${sortCodeFormat.slice(4,6)}`
    }else{sortCodeFormat=''}
      
    return (
      <div className="payment-page payment-summary row">
       {errorMsgs && <PaymentError errors={errorMsgs} aria-label={errorMsgs}/>}
        <div className="title" id="title_paymentSummary_test">
          <H1 tabIndex={0}>{pageTitle}</H1>
        </div>
        <div className="payment-summary-container payment-mask-bg">
          <div className="row">
          <div id='domestic-summary-to' className="columns small-12 medium-6" tabIndex={0}>
              <div>
                <Large className="payment-summary-index">{messages['app.payments.summary.to']}</Large>
              </div>
              <div>
                <div align="left" >
                  <div><Text secondary>{beneficiaryName}</Text></div>
                  { (envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) && paymentType.includes('domestic') ?
                    <div>
                          {ibanNo ?  <div><Text secondary>{messages['app.common.portfolio.bonds.account']}: {ibanNo}</Text></div> : 
                          <div><Text secondary>{accNo && messages['app.common.portfolio.bonds.account']+': '+accNo}</Text></div> }
                          <div><Text secondary>{bankName && bankName} {checkSortCode && sortCodeFormat}</Text></div>
                    </div>
                    :
                    <div>
                          { address1 &&  <div><Text secondary>{address1} {address2} </Text></div> }
                          { address3 && !isDomestic && <div><Text secondary>{address3} </Text></div> }
                          <div><Text secondary>{messages['app.payments.summary.accountLabel']}: {ibanNo}</Text></div>
                          <div><Text secondary> {isInternal ? messages['app.payments.portfolio.text']: bankName} {bankSwift} </Text> </div>
                    </div>
                  }
                </div>
              </div>
            </div>
            <div id='domestic-summary-from' className="columns small-12 medium-6" tabIndex={0}>
              <div>
                <Large className="payment-summary-index">{messages['app.payments.summary.from']}</Large>
              </div>
              <div className="from-section">
                <div className="account-detail">
                  <div><Text secondary>{accName}</Text></div>
                  <div><Text secondary>{accNo}</Text></div>
                  <div><Text secondary>{messages['app.payments.portfolio.text']} {pfId}</Text></div>
                </div>
                <div className="asOf-section">
                  <div>
                    <Currency
                      currency={accBalCode}
                      value={accBal}
                      renderProps={{
                        size: 'small',
                        style: styles.dateStyle
                      }}
                    /></div>
                  <div>
                    <div>
                      <Small secondary>{'('+messages['app.payments.asOfDate'] +' '+fmtAsOfDate+')'}</Small>
                    </div>
                  </div>
                </div>
                </div>
            </div>
          </div>
          <div className="row" tabIndex={0}>
          {/* Fix for WMCE-12376 - removed istemplateflow check */}
          {this.props.payments.isSaveEnabled && 
          <div id='domestic-summary-from' className="columns small-12 medium-6">
              <div align="left">
              <div className='checkBoxContainer'>
                <Checkbox
                  disabled
                  checked={this.props.payments.isSaveEnabled}
                  className = "checkBoxStyle"/>
                <Text disabled className='paymentHeading'>{messages['app.payment.templates.saveCheckbox.title']}</Text>
                </div>
                <div className="margin-top-10">
                  <Text className='paymentHeading'>{messages['app.payment.templates.templateName']}</Text>
                </div> 
                <div className="margin-top-5">
                  <Text>{this.props.payments.templateName}</Text>
                </div>
              </div>
          </div>}
            <div id='domestic-summary-details' className="columns small-12 medium-6">
              <div>
                <Large className="payment-summary-index">{messages['app.payments.summary.paymentDetails']}</Large>
              </div>
              <div>
                <div align="left" >
                  <div><Text secondary>{messages['app.payments.summary.amount']} <Currency value={currencyAmount?parseFloat(currencyAmount):null} currency={currencyAmountCode} renderProps={{ size: 'small' }} /></Text>
                  </div>
                  <div><Text secondary>{messages['app.payments.summary.execDate']} {fmtExecutionDate}</Text></div>
                  <div><Text secondary>{messages['app.payments.summary.valueDate']} {fmtValueDate}</Text></div>
                  {showCosts &&
                  <div><Text secondary>{messages['app.payments.summary.costs']} {costs}</Text></div>}
                  <div><Text secondary>{messages['app.payments.summary.paymentStatus']} {status}</Text></div>
                  {externalOrderId && <div><Text secondary>{messages['app.payments.summary.referenceNumber']} {externalOrderId}</Text></div>}
                  
                  {(envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) && this.props.payments.paymentReason &&
                    <div><Text secondary>
                    {`${messages['app.payment.reason']}: `} {this.props.payments.paymentReason}
                    </Text></div>
                  }

                  {remarks && <div><Text secondary>
                  { (envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) ? `${messages['app.payment.additional.information']}: ` : `${messages['app.payment.additional.beneficiary.information']}: ` }
                    {remarks}
                  </Text></div>}
                  
                  {/* {(envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) && !editable && !isModifyFlow && confirmable && <div>
                    
                    <Text secondary>{`${messages['app.payments.feeForTransactions']}`}</Text>&nbsp;
                    { costs && (costs === ALL_CHARGES_EN || costs === ALL_CHARGES_DE)&& <Text secondary>{`${messages['app.payments.fee.transaction.thirdPartyExpense']}`}</Text>}
                    
                  </div>} */}
                  { (envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) && forexText !== null && !editable && confirmable && !cancelable && <div><Text secondary>{forexText}</Text></div>}

                  <div>&nbsp;</div>
                  { (isInternational) && (envConfig.envConfig === EBANKINGWEBLUX) && <div><Text>{messages['app.psd2.payment.excute.xchngeLabel']}</Text></div>}
                </div>
              </div>
            </div>
          </div>
          <div className='payment-btn-block medium-6 medium-offset-6'>
            <div className='adviceBtn payment-btn'>
              <TransactionSecurityAdvice
              tertiary={ editable || confirmable || cancelable }
              isPaymentAdviceAvailble
              transaction={transactionDtsForAdvice}/>
            </div>
            {paymentSubmitDisabled && !editable && !cancelable && confirmable &&
              <div className='payment-btn-block medium-6 medium-offset-6'>
                <div className='adviceBtn payment-btn'>
                  <Button
                  testID="btn_confirmBtn_paymentSummary_test"
                  size="large"
                  onPress={this.goNewPayment} >
                  {messages['app.rmAccess.payments.button.newPayment']}
                  </Button>
                </div>

                <div className='adviceBtn payment-btn'>
                  <Button
                    testID="btn_confirmBtn_paymentSummary_test"
                    size="large"
                    onPress={this.onDone} >
                    {messages['app.rmAccess.payments.button.done']}
                  </Button>
                  </div>
              </div>
            }
            {confirmable && !paymentSubmitDisabled &&
            <div className='adviceBtn payment-btn'>
              <Button
                testID="btn_confirmBtn_paymentSummary_test"
                size="large"
                tertiary = {paymentSubmitDisabled}
                disabled = {paymentSubmitDisabled}
                onPress={this.onConfirm} >
                {messages['app.payments.summary.confirm']}
              </Button>
            </div>}
            {cancelable &&
            <div className='adviceBtn payment-btn'>
              <Button
                testID="btn_cancelBtn_paymentSummary_test"
                tertiary size="large"
                disabled={transactionId ? true : false}
                onPress={() => this.toggleModal('showCancelModal')} >
               {orderId? messages['app.manageContactDetails.delete'] : messages['app.payments.summary.discard']} 
              </Button>
            </div>}
            {editable &&
            <div className='adviceBtn payment-btn'>
              <Button
                testID="btn_modifyBtn_paymentSummary_test"
                size="large"
                onPress={this.onModify} 
                disabled={transactionId ? true : false}>
                {messages['app.payments.summary.modify']}
              </Button>
            </div>}
          </div>
          {transactionId && !cancelable && !editable &&
            <div style={{display:'flex', flexDirection:'row-reverse', paddingRight:'15px',paddingTop:'10px'}}>
              <Text secondary>{messages['app.psd2.payment.noCancelPayment']}{tppName}</Text>
            </div>
            }
        </div>
        {showConfirmationModal &&
        <ConfirmationModal
          messages={messages}
          orderId={orderId}
          refreshStatus={refreshStatus}
          cancelPayment={this.cancelPayment}
          donePayment={this.donePayment}
          onRefresh={this.onRefresh}
          onCancel={() => this.toggleModal('showCancelModal')}
          onTimeout={this.onTimeout}
        />}
        {showCancelModal &&
        <CancelModal
          messages={messages}
          onConfirm={(e) => this.cancelPayment(!orderId, false, true, e)}
          onCancel={() => this.toggleModal('showCancelModal', false)}
          order={orderId}                      
          isModifyFlow={isModifyFlow}
          onDone={this.onDone}
        />}
        {showStatusModal &&
        <StatusModal
          status={this.state.status}
          execDate={executionDate}
          messages={messages}
          onDone={this.onDone}
          onNewPayment={this.goNewPayment}
        />}
        {showExpireModal &&
        <Modal
          isActive
          hideCloseButton
          disableOutsideClick
          title={messages['app.warning.text']}
          onClose={this.onDone}
          header={messages['app.warning.text']}
          content={
            <div className="payment-expired-modal">
              <div className="padding-20" tabIndex={0}>
                <Text>{messages['app.payment.error.expired']}</Text>
              </div>
              <div className="modal-footer">
                <div className="okButton margin-bottom-10 margin-right-20">
                  <div className="payment-btn">
                    <Button fullWidth onPress={this.onDone}>
                      {messages['app.rmcallback.okMsg']}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          }/>
        }
      </div>
    )
  }
}

export default createContainer({
  $queries: {
    i18n: { messages: true, },
    changePage: { $call: 'ui.history.push' },
    payments: {
      isValidatingPayment: true,
      isFetchingTx: true,
      initializeTxFails: true,
      isModifyFlow: true,
      remarks: true,
      currentTx: true,
      refreshStatus : true,
      errorMsgs: true,
      paymentReason: true,
      initializeTx: { $call: 'initializeTx' },
      cancelTx : { $call: 'cancelTx'},
      resetForm: { $call: 'resetForm'},
      getRefreshStatus: { $call: 'getPaymentStatus' },
      setCreateNewModal: { $set: 'createNewModal' },
      paymentType: true,
      isCashFlow: true,
      setFlowFalse: { $set: 'isCashFlow' },
      isCashPaymentFlow: true,
      setIsCashPaymentFlow: { $set: 'isCashPaymentFlow' },
      setPosid: { $set: 'psPosId' },
      selectedDebitAcnt: true,
      isSaveEnabled: true,
      saveTemplate: {$call: 'saveUpdateTemplate'},
      templateName: true,
      transactionId:true,
      tppName:true,
      isRequestInvalid : true,
      setErrorMsg: { $set: 'errorMsgs' },
      isRequestInvalid : true,
      disableTabs:true,
      setDisableTabs: { $set: 'disableTabs'},
    },
    verifyChallengeResponse: { $call: 'payments.verifyChallengeResponse' },
    portfolio: {
        setAssetClassName: { $set: 'assetClassName' }
    },
    auth: { paymentSubmitDisabled: true },
  },
})(PaymentSummary);
